module.exports = __webpack_public_path__ + "pc/static/img/logo.74cc17e1.png";